import React, {useContext, useEffect, useState} from 'react';
import Jelly from './Jelly';
import {Spinner, styled} from '@volkswagen-onehub/components-core';
import Form from './Form';
import Maintenances from './Maintenances';
import {useAppSelector} from '../../store/hooks';
import {set as setVehicle} from '../../store/slice/vehicle';
import {useDispatch} from 'react-redux';
import {set as setModel} from '../../store/slice/model.response';
import {
  TrackingContext,
  TrackingEvents,
} from '../../store/context/modules/TrackingContext';

const DetailsContainer = styled.div``;

const ModelContainer = styled.div`
  display: grid;
  grid-template-columns: fr;
  row-gap: ${(props) => props.theme.size.dynamic0050};

  @media screen and (min-width: 768px) {
    grid-template-columns: 3fr 2fr;
    column-gap: ${(props) => props.theme.size.dynamic0050};
  }
`;

export default () => {
  const trackCtx = useContext(TrackingContext);

  const vehicle = useAppSelector((state) => state.vehicle.value);
  const model = useAppSelector((state) => state.model.value);
  const [show, setShow] = useState<boolean>(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!vehicle || !model) return;

    trackCtx?.init(
      TrackingEvents.FILTER_SEARCH_RESULT_LOAD,
      (vehicle.model as string).toUpperCase(),
      (vehicle.model as string).toUpperCase() + '-RESULT_LOAD',
      null,
      {
        results: [(vehicle.model as string).toUpperCase()],
        numberOfResults: 1,
        filterlist: [
          {
            type: 'multi_value',
            name: 'CG',
            values: [vehicle.model as string],
          },
          {
            type: 'single_value',
            name: 'ESV',
            values: [vehicle.model as string],
          },
        ],
      },
      null,
      {
        name: (vehicle.model as string).toLowerCase() + '-process-result-load',
        number: 2,
      },
    );
  }, [vehicle, model]);

  useEffect(() => {
    return () => {
      dispatch(setVehicle({value: null}));
      dispatch(setModel({value: null}));
    };
  }, []);

  return vehicle && model ? (
    <DetailsContainer>
      <ModelContainer>
        <Jelly model={vehicle.model as string} />
        <Form model={model} vehicle={vehicle} setShowMaintainance={setShow} />
      </ModelContainer>

      {show && <Maintenances />}
    </DetailsContainer>
  ) : (
    <Spinner />
  );
};
